import React from "react";
import Modal from "./Modal";
import SmallModal from "./SmallModal";
import { lineConverter } from "./helpers/skuToLineOp";
import * as opOrderStatsService from "../services/openprintStats.service";
import { IoIosRefresh } from "react-icons/io";

class OpFMvKY extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      allQueueFm: {},
      allQueueKy: {},
      allNumFm: null,
      allNumKy: null,
      todayQueueFm: {},
      todayQueueKy: {},
      todayNumFm: null,
      todayNumKy: null,
      readyFm: {},
      readyKy: {},
      readyTodayFm: {},
      readyTodayKy: {},
      spin: false
    }
  }
  
  componentDidMount() {
    this.setState({
      spin: true,
      allQueueFm: {},
      allQueueKy: {},
      allNumFm: null,
      allNumKy: null,
      todayQueueFm: {},
      todayQueueKy: {},
      todayNumFm: null,
      todayNumKy: null,
      readyFm: {},
      readyKy: {},
      readyTodayFm: {},
      readyTodayKy: {},
    });
    opOrderStatsService.getFm_Ky().then(response => {
      //console.log(response);
      let allFm = JSON.parse(response.allObjFm);
      let allKy = JSON.parse(response.allObjKy);
      let allFmNum = response.allNumFm;
      let allKyNum = response.allNumKy;
      let todayFm = JSON.parse(response.todayObjFm);
      let todayKy = JSON.parse(response.todayObjKy);
      let todayFmNum = response.todayNumFm;
      let todayKyNum = response.todayNumKy;

      let allFmLines = this.calculateByLine(allFm.index, allFm.data);
      let allKyLines = this.calculateByLine(allKy.index, allKy.data);
      let todayFmLines = this.calculateByLineToday(todayFm.data);
      let todayKyLines = this.calculateByLineToday(todayKy.data);

      this.setState({ 
        spin: false,
        allQueueFm: allFm,
        allQueueKy: allKy,
        allNumFm: allFmNum,
        allNumKy: allKyNum,
        todayQueueFm: todayFm,
        todayQueueKy: todayKy,
        todayNumFm: todayFmNum,
        todayNumKy: todayKyNum,
        readyFm: allFmLines,
        readyKy: allKyLines,
        readyTodayFm: todayFmLines,
        readyTodayKy: todayKyLines
      });
    }).catch(err => {
      console.log(err);
    })
  }

  calculateByLine = (skus, quantities) => {
    let lineObj = {};
    skus.map((sku, index) => {
      let line = lineConverter[sku];
      if (lineObj[line]) {
        lineObj[line] += quantities[index][0];
      } else {
        lineObj[line] = quantities[index][0];
      }
    })
    return lineObj;
  }

  calculateByLineToday = (data) => {
    let lineObj = {};
    data.map((row, index) => {
      let line = lineConverter[row[1]];
      if (lineObj[line]) {
        lineObj[line] += row[2];
      } else {
        lineObj[line] = row[2];
      }
    })
    return lineObj;
  }

  refresh = () => {
    this.componentDidMount();
    return;
  }
  
  render() {
    return (      
      <div className="shadow-lg ml-0.5 mt-1 px-4 py-1.5 w-full bg-gray-800 relative grow">
        <div>
          {this.state.spin ? 
            <svg role="status" className="inline w-8 h-8 mr-2 text-gray-200 float-center animate-spin dark:text-gray-600 fill-gray-600 dark:fill-gray-300" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
              <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
            </svg> : null }
        </div>
        <span className="text-xs w-max text-white dark:text-white font-semibold border-b border-gray-200">
          Incoming Items FM  <Modal data={this.state.todayQueueFm} numCols={3}/>
        </span>
        <button onClick={this.refresh} className="float-right text-md text-white">
          <IoIosRefresh className="hover:text-green-700" />
        </button>
        <div className="flex items-end space-x-2 my-2">
          <p className="text-2xl text-white dark:text-white font-bold">
            {this.state.todayNumFm}
          </p>
          <div className="flex items-end space-x-2 my-1 mb-1">
            <div className="flex">
              <p className="text-xs text-white dark:text-white font-bold">
                Mugs: {this.state.readyTodayFm['Mug'] ? this.state.readyTodayFm['Mug'] : 0}
              </p>
            </div>
            <div className="flex">
              <p className="text-xs text-white dark:text-white font-bold">
                Posters: {this.state.readyTodayFm['Poster'] ? this.state.readyTodayFm['Poster'] : 0}
              </p>
            </div>
            <div className="flex">
              <p className="text-xs text-white dark:text-white font-bold">
                Press: {this.state.readyTodayFm['Press'] ? this.state.readyTodayFm['Press'] : 0}
              </p>
            </div>
            <div className="flex">
              <p className="text-xs text-white dark:text-white font-bold">
                Other: {this.state.todayNumFm - (this.state.readyTodayFm['Press'] ? this.state.readyTodayFm['Press'] : 0) - (this.state.readyTodayFm['Poster'] ? this.state.readyTodayFm['Poster'] : 0) - (this.state.readyTodayFm['Mug'] ? this.state.readyTodayFm['Mug'] : 0)}
              </p>
            </div>
          </div>
        </div>
        
        <hr className="mb-1" />
        <span className="text-xs w-max text-white dark:text-white font-semibold border-b border-gray-200">
          Total Items FM  <Modal data={this.state.allQueueFm} numCols={4} index={'SKU'} dept={true}  />
        </span>
        <div className="flex items-end space-x-2 my-2">
          <p className="text-2xl text-white dark:text-white font-bold">
            {this.state.allNumFm}
          </p>
          <div className="flex items-end space-x-2 my-1 mb-1">
            <div className="flex">
              <p className="text-xs text-white dark:text-white font-bold">
                Mugs: {this.state.readyFm['Mug'] ? this.state.readyFm['Mug'] : 0}
              </p>
            </div>
            <div className="flex">
              <p className="text-xs text-white dark:text-white font-bold">
                Posters: {this.state.readyFm['Poster'] ? this.state.readyFm['Poster'] : 0}
              </p>
            </div>
            <div className="flex">
              <p className="text-xs text-white dark:text-white font-bold">
                Press: {this.state.readyFm['Press'] ? this.state.readyFm['Press'] : 0}
              </p>
            </div>
            <div className="flex">
              <p className="text-xs text-white dark:text-white font-bold">
                Other: {this.state.allNumFm - (this.state.readyFm['Press'] ? this.state.readyFm['Press'] : 0) - (this.state.readyFm['Poster'] ? this.state.readyFm['Poster'] : 0) - (this.state.readyFm['Mug'] ? this.state.readyFm['Mug'] : 0)}
              </p>
            </div>
          </div>
        </div>
        
        <hr className="mb-1" />
        <span className="text-xs w-max text-white dark:text-white font-semibold border-b border-gray-200">
          Incoming Items Ky  <Modal data={this.state.todayQueueKy} numCols={3}/>
        </span>
        <div className="flex items-end space-x-2 my-2">
          <p className="text-2xl text-white dark:text-white font-bold">
            {this.state.todayNumKy}
          </p>
          <div className="flex items-end space-x-2 my-1 mb-1">
            <div className="flex">
              <p className="text-xs text-white dark:text-white font-bold">
                Mugs: {this.state.readyTodayKy['Mug'] ? this.state.readyTodayKy['Mug'] : 0}
              </p>
            </div>
            <div className="flex">
              <p className="text-xs text-white dark:text-white font-bold">
                Posters: {this.state.readyTodayKy['Poster'] ? this.state.readyTodayKy['Poster'] : 0}
              </p>
            </div>
            <div className="flex">
              <p className="text-xs text-white dark:text-white font-bold">
                Press: {this.state.readyTodayKy['Press'] ? this.state.readyTodayKy['Press'] : 0}
              </p>
            </div>
            <div className="flex">
              <p className="text-xs text-white dark:text-white font-bold">
                Other: {this.state.todayNumKy - (this.state.readyTodayKy['Press'] ? this.state.readyTodayKy['Press'] : 0) - (this.state.readyTodayKy['Poster'] ? this.state.readyTodayKy['Poster'] : 0) - (this.state.readyTodayKy['Mug'] ? this.state.readyTodayKy['Mug'] : 0)}
              </p>
            </div>
          </div>
        </div>
        <hr className="mb-1" />
        <span className="text-xs w-max text-white dark:text-white font-semibold border-b border-gray-200">
          Total Items Ky  <Modal data={this.state.allQueueKy} numCols={4} index={'SKU'} dept={true}  />
        </span>
        <div className="flex items-end space-x-2 my-2">
          <p className="text-2xl text-white dark:text-white font-bold">
            {this.state.allNumKy}
          </p>
          <div className="flex items-end space-x-2 my-1 mb-1">
            <div className="flex">
              <p className="text-xs text-white dark:text-white font-bold">
                Mugs: {this.state.readyKy['Mug'] ? this.state.readyKy['Mug'] : 0}
              </p>
            </div>
            <div className="flex">
              <p className="text-xs text-white dark:text-white font-bold">
                Posters: {this.state.readyKy['Poster'] ? this.state.readyKy['Poster'] : 0}
              </p>
            </div>
            <div className="flex">
              <p className="text-xs text-white dark:text-white font-bold">
                Press: {this.state.readyKy['Press'] ? this.state.readyKy['Press'] : 0}
              </p>
            </div>
            <div className="flex">
              <p className="text-xs text-white dark:text-white font-bold">
                Other: {this.state.allNumKy - (this.state.readyKy['Press'] ? this.state.readyKy['Press'] : 0) - (this.state.readyKy['Poster'] ? this.state.readyKy['Poster'] : 0) - (this.state.readyKy['Mug'] ? this.state.readyKy['Mug'] : 0)}
              </p>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
  
export default OpFMvKY;
